export default "__VITE_PUBLIC_ASSET__97fb48f8__"